<template>
  <li class="divider"></li>
</template>
<script>
  export default {
    name: 'DropdownDivider'
  }
</script>



// WEBPACK FOOTER //
// dropdown-divider.vue?e8a1963c